import Service from '@/helpers/service'

export default {

    show(id) {
        return Service().get('att-log/show/'+id);
    },
    create(params) {
        return Service().post('att-log/create', params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    update(id, params) {
        return Service().post('att-log/update/'+id, params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    deleteLog(id) {
        return Service().post('att-log/delete/'+id);
    },
}